import { useEffect } from 'react';
var overlays = [];
var portalDiv;
export function useOverlayManager(callback, requestRender) {
  useEffect(function () {
    // already queued? shouldn't happen due to cleanup function
    if (overlays.indexOf(callback) !== -1) {
      // if still requesting render just ignore call
      if (requestRender) {
        return function () {
          removeFromQAndCheck(callback);
        };
      } // otherwise remove from queue


      removeFromQAndCheck(callback);
      return;
    } // ignore if not queued and not requesting render


    if (!requestRender) {
      return;
    } // add to queue if not queued already but requesting render


    addToQAndCheck(callback);
    return function () {
      removeFromQAndCheck(callback);
    };
  }, [callback, requestRender]);
}

function removeFromQAndCheck(callback) {
  callback();
  var cbIdx = overlays.indexOf(callback);
  if (cbIdx === -1) return; // should never happen

  overlays.splice(cbIdx, 1);

  if (overlays.length === 0) {
    document.body.removeChild(portalDiv);
    portalDiv = undefined;
  } else if (cbIdx === 0 && overlays[0]) {
    window.requestAnimationFrame(function () {
      if (overlays[0]) {
        overlays[0](portalDiv);
      }
    });
  }
}

function addToQAndCheck(callback) {
  // add in order
  overlays.push(callback); // if it's first create portal div and notify caller

  if (callback === overlays[0]) {
    portalDiv = document.createElement('div');
    document.body.appendChild(portalDiv);
    window.requestAnimationFrame(function () {
      callback(portalDiv);
    });
  }
}